module.exports = __webpack_public_path__ + "img/delete.4c22988b.svg";